const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Wand"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.959,2.196l-1.054,2.863l2.398,1.89l-3.05,-0.121l-1.054,2.862l-0.831,-2.937l-3.05,-0.122l2.537,-1.694l-0.831,-2.937l2.399,1.89l2.536,-1.694Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.088,7.839c-0.425,-0.349 -1.053,-0.287 -1.402,0.138l-9.137,11.13c-0.349,0.425 -0.287,1.054 0.138,1.403l1.54,1.264c0.425,0.349 1.053,0.287 1.402,-0.138l9.137,-11.131c0.349,-0.425 0.287,-1.053 -0.138,-1.402l-1.54,-1.264Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.797,2.736l-0.287,1.752l1.577,0.814l-1.755,0.268l-0.287,1.752l-0.797,-1.586l-1.755,0.269l1.262,-1.249l-0.798,-1.586l1.578,0.814l1.262,-1.248Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.413,15.422l0.288,-1.752l-1.578,-0.815l1.755,-0.268l0.287,-1.752l0.798,1.586l1.754,-0.268l-1.262,1.248l0.798,1.587l-1.578,-0.815l-1.262,1.249Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.378,2l-0.158,0.979l0.885,0.457l-0.984,0.148l-0.158,0.978l-0.449,-0.887l-0.984,0.148l0.706,-0.697l-0.449,-0.887l0.885,0.457l0.706,-0.696Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.832,16.157l0.159,-0.978l-0.886,-0.457l0.984,-0.148l0.158,-0.979l0.45,0.888l0.983,-0.148l-0.706,0.696l0.449,0.887l-0.885,-0.457l-0.706,0.696Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.309,8.328l-0.906,0.699l0.385,1.078l-0.945,-0.646l-0.906,0.698l0.323,-1.097l-0.945,-0.646l1.144,-0.033l0.322,-1.097l0.385,1.077l1.143,-0.033Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.901,9.829l0.906,-0.699l-0.385,-1.077l0.945,0.646l0.906,-0.699l-0.322,1.098l0.944,0.645l-1.144,0.033l-0.322,1.098l-0.384,-1.078l-1.144,0.033Z",
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWand);
export default __webpack_public_path__ + "static/media/wand.afda5d509c4c2b72a5bd4921198d3ec1.svg";
export { ForwardRef as ReactComponent };